import React, {useLayoutEffect} from 'react';
import styles from './styles';
import Header from './Header';
import {ScrollContext} from '../Utils/ScrollContext';
// import HeaderModal from './HeaderModal';
// import InfoModal from './InfoModal';
// import GroupActionMenu from './GroupActionMenu';
// import {DragTableContext} from '../Utils/DragTableContext';

const Headers = props => {
// const {dragDistance} = React.useContext(DragTableContext);

  const {headers, scrollEffect} = React.useContext(ScrollContext);
  const {controller} = props;

  useLayoutEffect(() => scrollEffect());

  const dragParentStyles = {
    width: props.dragWidth,
    marginLeft: '15px',
  }
  const dragContentStyles = {
    display: 'inline-block',
    transform: 'translateX(0px)',
  }

  const memoizedHeaders = React.useMemo(() => props.headers.map((obj, i) => {
    return <Header
      controller={controller}
      id={obj.id}
      index={i}
      key={obj.id}
      data={obj}
      last={i === props.headers.length - 1}
      first={i === 0}
      options={props.options}
    />;
}), [props.headers, controller.searchingHeader, controller.queryString, props.width])

  return(
    <React.Fragment>
      <div style={{
          ...styles.container,
          position: headers ? 'fixed' : 'relative',
          boxShadow: headers ? '0 10px 6px -6px rgba(0,0,0,0.1)' : 'none',
          transition: '.2s ease-out',
          top: headers ? (props.customTopOffset || 0) : 0,
          width: props.width,
        }}
      >
        <div style={{position: 'relative', overflowX: 'hidden', width: '100%'}}>
          {/* Placeholder to accoutn for line number width */}
          <div style={styles.lineNumberPlaceholer}/>
            <div style={dragParentStyles}>
              <div style={dragContentStyles} id={controller.tableID + '_parent_headers'}>
                {memoizedHeaders}
              </div>
            </div>
          </div>
        </div>
      {headers && <div style={{height: '55px', width: '100%'}}/>}
      {/* Modals and Menus */}
    </React.Fragment>
  )
}

export default Headers;
